import { Routes } from '@angular/router';
import { templateUnsavedGuard } from '@website-builder/guards/template-unsaved.guard';

export const appRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./landing-page/landing-page/landing-page.component').then(m => m.LandingPageComponent),
  },
  {
    path: 'website-builder/:websiteId',
    loadChildren: () => import('./website-builder/website-builder.routes').then(m => m.websiteBuilderRoutes),
    canDeactivate: [templateUnsavedGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
